export default __webpack_public_path__ + "static/media/kirvano.alt.50d8e1c6.png";